import AdvertiserApi from '@/api/AdvertiserApi'

/**
 * ログイン後に行く画面のルーティングパスを、
 * アカウント情報から判定する関数
 * ※ ログイン後に行く画面がアカウントによって異なるため。
 * ※※ 「ログインLP：運用画面」「ログインLP：レポート画面」「広告主ダッシュボード：運用画面」の３種類。
 * @param {Object} accountObj アカウント情報
 * @return {string} 画面のパス
 */

export default async ({ belongType, userType, belongId }) => {
  // ルーティング先を返す
  if (userType === 'super admin' || userType === 'system operator') {
    return '/loginlp/report'
  }

  switch (belongType) {
    // system owner, agencyはログイン後、ログインLP：運用画面に移動する
    case 'system owner': {
      return '/loginlp/operation'
    }
    case 'agency': {
      return '/loginlp/operation'
    }
    // advertiserのみ、広告主dashboardに移動する
    case 'advertiser': {
      // ここで、agencyのidを取得するために、advertiserApiを投げる
      const ret = await AdvertiserApi.fetchAdvertiser(belongId)
      const agencyId = ret.item.agencyId
      return `/agencies/${agencyId}/advertisers/${belongId}/insertion_orders`
    }
    // 当てはまらないケースの場合、loginページに移動する
    default:
      return '/login'
  }
}
